import React from 'react';
import { Grid } from '@material-ui/core';
import {
  Header,
  Page,
  Content,
  HeaderLabel,
  // SupportButton,
} from '@backstage/core-components';

import RepoStatusCard from './subcomponents/RepoStatusCard';

const EngagementTracker = () => (
  <Page themeId="tool">
    <Header title="Engagement Tracker" subtitle="Import Your Repos">
      <HeaderLabel label="Owner" value="Backstage" />
      <HeaderLabel label="Lifecycle" value="Alpha" />
    </Header>
    <Content>
      {/* <SupportButton /> float right */}
      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12}>
          <RepoStatusCard />
        </Grid>
      </Grid>
    </Content>
  </Page>
);

export { EngagementTracker as default };
